import { AnalyticsBrowser } from "@segment/analytics-next";
import isServer from "@utils/is-server";
import Cookies from "js-cookie";

export const analytics = AnalyticsBrowser.load({ writeKey: process.env.NEXT_PUBLIC_SEGMENT_KEY });

const originalTrack = analytics.track;

analytics.track = function (event, properties) {
  if (isServer()) return;

  const jwt = Cookies.get("jwt-token");
  if (!jwt) return;

  return originalTrack.call(this, event, properties);
}

const originalPage = analytics.page;

analytics.page = function (event, properties) {
  if (isServer()) return;

  const jwt = Cookies.get("jwt-token");
  if (!jwt) return;

  return originalPage.call(this, event, properties);
}
